<!-- Pestaña "PREMIOS" flotante con gradiente magma -->
<button class="prizes-tab" type="button" (click)="toggle()" [class.is-open]="isOpen">
    <i class="mdi tab-chev" [ngClass]="isOpen ? 'mdi-chevron-right' : 'mdi-chevron-left'"></i>
    <span class="prizes-tab-label">PREMIOS</span>
</button>

<!-- Overlay para cerrar al tocar fuera -->
<div class="prizes-overlay" *ngIf="isOpen" (click)="close()"></div>

<!-- Panel deslizante -->
<aside class="prizes-panel" [class.is-open]="isOpen">
    <div class="prizes-panel-header">
        <div class="prizes-panel-title">¡Tu próxima raspadita podría darte uno de estos premios!</div>
        <button class="prizes-close" type="button" (click)="close()" aria-label="Cerrar">
            <i class="mdi mdi-close"></i>
        </button>
    </div>

    <div class="prizes-list">
        <ng-container *ngFor="let coupon of coupons; let i = index">
            <div class="prize-item" [class.is-expanded]="expandedIndex === i">
                <div class="prize-summary" (click)="toggleExpanded(i)">
                    <div class="prize-thumb">
                        <img *ngIf="coupon?.thumbnailUrl || coupon?.imageUrl" [src]="coupon?.thumbnailUrl || coupon?.imageUrl" alt="">
                        <i *ngIf="!coupon?.thumbnailUrl && !coupon?.imageUrl" class="mdi mdi-gift-outline placeholder-icon"></i>
                    </div>
                    <div class="prize-info">
                        <div class="prize-name">{{ coupon?.name }}</div>
                        <div class="prize-pct" *ngIf="couponPercent(coupon) as pct">Probabilidad: {{ pct }}</div>
                    </div>
                    <i class="mdi prize-chev" [ngClass]="expandedIndex === i ? 'mdi-chevron-up' : 'mdi-chevron-down'"></i>
                </div>

                <div class="prize-detail" *ngIf="expandedIndex === i">
                    <div class="prize-desc" *ngIf="coupon?.description" [innerHTML]="coupon?.description"></div>
                    <a *ngIf="coupon?.terms" href="javascript:void(0)" class="prize-terms" (click)="openTerms(coupon)">
                        Términos y condiciones
                    </a>
                </div>
            </div>
        </ng-container>

        <div class="prizes-empty" *ngIf="!coupons?.length">
            Aún no hay premios disponibles
        </div>
    </div>
</aside>

<!-- Modal Términos y condiciones -->
<ng-template #termsModal let-modal>
    <div class="modal-body">
        <div class="scratch-terms-title">Términos y condiciones</div>
        <div class="scratch-terms-name" *ngIf="termsCoupon?.name">{{ termsCoupon?.name }}</div>
        <div class="scratch-terms-body" [innerHTML]="termsCoupon?.terms"></div>
        <div class="scratch-terms-actions">
            <button type="button" class="scratch-terms-close" (click)="modal.dismiss()">Cerrar</button>
        </div>
    </div>
</ng-template>
